import React from 'react';
// import {sliderPropTypes} from './common/createSlider';
import createSliderWithTooltip from './createSliderWithTooltip';
import Handle from './Handle';
import Range from './Range';
import Slider from './Slider';
import type {CommonSliderProps, ComponentWrapperProps, SliderSingProps} from './iSlider'
import { WithConfigConsumer } from '../../wui-provider/src/context';

import type { ConfigConsumerProps} from '../../wui-provider/src/iProvider'
import { ConfigConsumer } from '../../wui-provider/src/context';
import omit from 'omit.js';
import type {RangeProps} from './iSlider'


const DemoRange: React.FC<Partial<RangeProps>> = (props) => {
    return (
        <ConfigConsumer>
            {
                (configProps: ConfigConsumerProps) => {
                    return <Range {...omit(configProps, ["getPrefixCls", "renderEmpty", "provider"])} {...props}/>;
                }
            }
        </ConfigConsumer>
    );
};
// const propTypes = {...sliderPropTypes}

// Slider.Range = Range;
// Slider.Handle = Handle;
// Slider.createSliderWithTooltip = createSliderWithTooltip;

const SliderRangeTooltip = createSliderWithTooltip(Range);
const SliderTooltip = createSliderWithTooltip(Slider);

const SliderComponents: React.FC<CommonSliderProps & ComponentWrapperProps> = (props) => {
    const {
        range,
        tipFormatter,
        getTooltipPopupContainer,
        tooltipPlacement,
        tooltipVisible,
        tooltip,
        ...others
    } = props;

    const tooltipProps = {
        tipFormatter: tipFormatter === undefined ? tooltip?.formatter : tipFormatter,
        getTooltipPopupContainer: getTooltipPopupContainer === undefined ? tooltip?.getPopupContainer : getTooltipPopupContainer,
        tooltipPlacement: tooltipPlacement === undefined ? tooltip?.placement : tooltipPlacement,
        tooltipVisible: tooltipVisible === undefined ? tooltip?.open : tooltipVisible,
    };

    if (props && props.hasOwnProperty('range') && range && (props.hasOwnProperty('tipFormatter') || tooltip !== undefined)) {
        return (
            <SliderRangeTooltip range {...tooltipProps} {...others} />
        );
    } else if (props && props.hasOwnProperty('range') && range) {
        return (
            <DemoRange range {...others} />
        );
    } else if (props && (props.hasOwnProperty('tipFormatter') || tooltip !== undefined)) {
        return (
            <SliderTooltip {...tooltipProps} {...others} />
        );
    } else {
        return (
            <Slider {...others} />
        );
    }
};

// 创建一个包装后的组件，应用装饰器
const WrappedSliderComponents = WithConfigConsumer({name: "slider"})(SliderComponents);

// 将静态属性添加到包装后的组件上
WrappedSliderComponents.Range = DemoRange;
WrappedSliderComponents.Handle = Handle;
WrappedSliderComponents.createSliderWithTooltip = createSliderWithTooltip;
// WrappedSliderComponents.propTypes = propTypes;

interface CompoundedComponent extends React.FC<SliderSingProps> {
    Range: typeof DemoRange;
    Handle: typeof Handle;
    createSliderWithTooltip: typeof createSliderWithTooltip;
}

export default WrappedSliderComponents as CompoundedComponent;

